import { render, staticRenderFns } from "./Calendars.vue?vue&type=template&id=5acdc363&scoped=true"
import script from "./Calendars.vue?vue&type=script&lang=js"
export * from "./Calendars.vue?vue&type=script&lang=js"
import style0 from "./Calendars.vue?vue&type=style&index=0&id=5acdc363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acdc363",
  null
  
)

export default component.exports